import QuizSubmissionsLayout from 'components/QuizSubmissions/QuizSubmissionsLayout';

const Tablet = (props) => <QuizSubmissionsLayout device={'tablet'} {...props} />;

export default Tablet;
